export default __webpack_public_path__ + "static/media/pc.17b5790f.jpg";